
import React, { useState } from 'react';
import './warning.css';

const Warning = ({ text, src }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>

      <div className="warning_container">
        <img src={src} alt="icon" className="warning_img" />
        {text}
      </div>
    </>

  )
}

export default Warning;